module.exports = __webpack_public_path__ + "media/images/admin/logo_text_white1-603007af103c8a0f4712412798486df3.png";